import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = "查看更多" }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-accent-500"></span>
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line text-lg"></i>
          </span>
        </Link>
      )}
    </div>
  );
}